import { render, staticRenderFns } from "./sjlhStore.vue?vue&type=template&id=06565258&scoped=true&"
import script from "./sjlhStore.vue?vue&type=script&lang=js&"
export * from "./sjlhStore.vue?vue&type=script&lang=js&"
import style0 from "./sjlhStore.vue?vue&type=style&index=0&id=06565258&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06565258",
  null
  
)

export default component.exports